import { FC } from 'react';
import { FillTag, OutlineTag, Text } from '@doda/io-react/common';
import { JobRelatedInfoResponse } from '@doda/api-client/aspida/@types';
import styles from './index.module.scss';

/**
 * 関連情報リストアイテム
 * @argument JobRelatedInfoResponse 関連情報リスト
 */
export const ListItem: FC<JobRelatedInfoResponse> = ({
  url,
  text,
  isDeadline,
  isNew,
}) => {
  const isShowTag = isNew || isDeadline;
  return (
    <li className={styles['jobSearchDetail-relationInformationListItem']}>
      <a
        className={styles['jobSearchDetail-relationInformationListItem__link']}
        href={url}
        target="_blank"
        rel="noopener"
      >
        <Text as="p" color="blue" style={{ display: 'inline' }}>
          {text}
        </Text>
      </a>
      {isShowTag && (
        <div
          className={
            styles['jobSearchDetail-relationInformationListItem__tagList']
          }
        >
          {isNew && (
            <FillTag
              color="red"
              className={
                styles['jobSearchDetail-relationInformationListItem__tag']
              }
            >
              NEW
            </FillTag>
          )}
          {isDeadline && (
            <OutlineTag
              color="red"
              className={
                styles['jobSearchDetail-relationInformationListItem__tag']
              }
            >
              締切間近
            </OutlineTag>
          )}
        </div>
      )}
    </li>
  );
};
